import { createReducer, on } from '@ngrx/store';
import { 
    cargaEntrada, 
    cargaEntradaEmpresa,  
    cargaEntradaTema,
    cargaEntradaTipo,
    cargaEntradaAnalista, 
    cargaEntradaSupervisor,
    cargaEntradaCoordinador,
    cargaEntradaModoEntrada,
    resetEntrada, 
    cargaEntradaPrioridad,
    cargaEntradaFolio,
    cargaEntradaRemitente,
    cargaEntradaCampos
} from './actions';
import { iEntrada, mEntrada } from '../../entrada/entrada.interface';

export const initialState: iEntrada = mEntrada;

export const entradaReducer = createReducer(
    initialState,
    on(cargaEntrada, (state, payload) => {
        return { ...state, ...payload.oEntrada };
    }),
    on(cargaEntradaRemitente, (state, payload) => {
        return { 
            ...state,
            remitente: payload.oRemitente.id,
            remitente_correo: payload.oRemitente.mail,
            remitente_descripcion: `${payload.oRemitente.nombre} ${payload.oRemitente.apellido} | ${payload.oRemitente.mail}`,
            vip: payload.oRemitente.vip?true:false
        };
    }),
    on(cargaEntradaEmpresa, (state, payload) => {
        return { 
            ...state, 
            empresa: payload.oEmpresa.id, 
            empresa_descripcion: payload.oEmpresa.descripcion
        };
    }),
    on(cargaEntradaTema, (state, payload) => {
        return { 
            ...state, 
            tema: payload.oTema.id,
            tema_descripcion: payload.oTema.descripcion
        };
    }),
    on(cargaEntradaTipo, (state, payload) => {
        return { 
            ...state, 
            tipo: payload.oTipo.id,
            tipo_descripcion: payload.oTipo.descripcion
        };
    }),
    on(cargaEntradaAnalista, (state, payload) => {
        return { 
            ...state, 
            analista: payload.oAnalista.id,
            analista_descripcion: `${payload.oAnalista.nombre} | ${payload.oAnalista.mail}`
        };
    }),
    on(cargaEntradaSupervisor, (state, payload) => {
        return { 
            ...state, 
            supervisor: payload.oSupervisor.id,
            supervisor_descripcion: `${payload.oSupervisor.nombre} | ${payload.oSupervisor.mail}`
        };
    }),
    on(cargaEntradaCoordinador, (state, payload) => {
        return { 
            ...state, 
            coordinador: payload.oCoordinador.id,
            coordinador_descripcion: `${payload.oCoordinador.nombre} | ${payload.oCoordinador.mail}`
        };
    }),
    on(cargaEntradaModoEntrada, (state, payload) => {
        return { 
            ...state, 
            modo_entrada: payload.oModoEntrada.id, 
            modo_entrada_descripcion: payload.oModoEntrada.descripcion
        };
    }),
    on(cargaEntradaPrioridad, (state, payload) => {
        return { 
            ...state, 
            prioridad: payload.oPrioridad.id, 
            prioridad_descripcion: payload.oPrioridad.descripcion
        };
    }),
    on(cargaEntradaFolio, (state, payload) => {
        return { 
            ...state, 
            folio: payload.oFolio.folio, 
        };
    }),
    on(cargaEntradaCampos, (state,  payload) => {
        return { 
            ...state, 
            ...payload.oData
        };
    }),
    on(resetEntrada, (state,  payload) => {
        return initialState;
    })
);